import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { Bell } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ReminderValues } from 'modules/trainings/components/NewReminder/useNewReminder'
import { SessionData } from 'modules/trainings/components/Revamp/NewClassWizard/hooks/useNewClassWizardSteps'

export const ReminderPreview = ({
  reminderData,
  index,
  setCreating,
  setReminderData,
  setCurrentIndex,
  onDelete,
}: {
  reminderData: ReminderValues
  index: number
  data: SessionData
  setCurrentData: (value: SessionData) => void
  setReminderData: (value: ReminderValues) => void
  setCreating: (value: boolean) => void
  setCurrentIndex: (value: number) => void
  onDelete: (reminderId: number, index: number) => void
}) => {
  const { access } = useCurrentSession()
  const locale = access.locale || 'en'

  const previewText = () => {
    const date = new Date(reminderData.scheduledAt)

    return new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(date)
  }

  const reminderPreviewText = () => {
    switch (reminderData.timeframe) {
      case 'oneday':
        return i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.event_data_step.event_box.timeframe_options.one_day'
        )
      case 'onehour':
        return i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.event_data_step.event_box.timeframe_options.one_hour'
        )
      case 'oneweek':
        return i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.event_data_step.event_box.timeframe_options.one_week'
        )
      case 'threedays':
        return i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.event_data_step.event_box.timeframe_options.three_days'
        )
      case 'twodays':
        return i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.event_data_step.event_box.timeframe_options.two_days'
        )
      default:
        return previewText()
    }
  }

  return (
    <Box
      style={{ padding: '16px 24px' }}
      borderRadius={{ all: 'abs016' }}
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      gap="s12"
      padding="s16"
      background="grey000White"
    >
      <Box alignItems="center" justifyContent="spaceBetween" flexDirection="row">
        <Text weight="bold" size="200" color="grey1000">
          {reminderData.name}
        </Text>
        <Box flexDirection="row" gap="s8">
          {!reminderData.id && (
            <Button
              iconName="pencil"
              type="secondary"
              onClick={() => {
                setCreating(true), setReminderData(reminderData), setCurrentIndex(index)
              }}
            />
          )}
          <Button
            iconName="delete"
            type="secondary"
            onClick={() => onDelete(Number(reminderData.id), index)}
          />
        </Box>
      </Box>
      <Box gap="s12" alignItems="center" flexDirection="row">
        <F0TagRaw icon={Bell} text={reminderPreviewText()} />
        {reminderData.timeframe !== 'custom' && (
          <Text size="200" color="grey1000">
            {previewText()}
          </Text>
        )}
      </Box>
    </Box>
  )
}
